import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  cardBox: {
    marginTop: '1.25rem',
    borderRadius: '0.313rem',
    border: '0.063rem solid #E9E9E9',
    boxShadow: 'rgba(0, 0, 0, 0.35) 0rem 0.313rem 0.938rem;',
  },
  iconStyle: {
    fontSize: '1.188rem',
    marginLeft: '0.125rem',
  },
  paginationStyle: {
    marginTop: '0.938rem',
    alignItems: 'center'
  },
  titleStyle: {
  width: "8.75rem",
  overflow: "hidden",
  position: "relative",
  textDecoration: "none",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
  },
  statusCompleted: {
    borderLeft: `0.313rem solid #008000`,
  },
  statusPending: {
    borderLeft: `0.313rem solid #D2691E`,
  },
  sortIconStyle: {
    gap: '2.5rem',
  },
});
